import React from 'react';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';

import Tooltip from 'src/components/tooltip';
import Icon from 'shared/components/icon';
import Stamp, {BLUE} from 'src/components/Stamp/Stamp';

const propTypes = {
  showTooltipFlag: PropTypes.bool,
};

const UsCitizenshipRequired = ({showTooltipFlag = false}) => {
  const infoText = 'Add citizenship for eligibility';
  if (!showTooltipFlag) {
    return (
      <Stamp color={BLUE}>
        <Link to="/account-settings">
          <div className="college-earnings-no-earnings-status-text-with-cta">
            <div className="college-earnings-no-earnings-status-text-content">{infoText}</div>

            <div className="college-earnings-no-earnings-status-cta-icon">
              <Icon iconType="chevron-right" />
            </div>
          </div>
        </Link>
      </Stamp>
    );
  }

  return (
    <div className="college-earnings-no-earnings-status-text-content">
      <Tooltip title={infoText}>
        <div>
          <Stamp color={BLUE} className="flag">
            <Icon iconType="flag" color="blue" />
          </Stamp>
        </div>
      </Tooltip>
    </div>
  );
};

UsCitizenshipRequired.propTypes = propTypes;
export default UsCitizenshipRequired;
